export interface ITranslation {
    id: number,
    default: string
}

interface IUITranslations {
    PhotoRoutePage: {
        FrequentlyUsed: ITranslation,
        OtherDestinations: ITranslation,
        ControlsPanel: {
            LeftSide: {
                FromLabel: ITranslation,
                FromPlaceholder: ITranslation,
                ToLabel: ITranslation,
                ToPlaceholder: ITranslation
            }
        },
        WelcomeBanner: {
            ImportantHeader: ITranslation
        }
        PathRating: {
            Question: ITranslation,
            PositiveAnswer: ITranslation,
            NegativeAnswer: ITranslation,
            ThankYouMessage: ITranslation
        },
        ReverseRouteLink: ITranslation,
        PathNotFound: ITranslation,
        Location: ITranslation,
    }
    GettingToPage: {
        HeaderQuestion: ITranslation,
        ArrivingByCar: ITranslation,
        ParkTheCar: ITranslation
        Wizard: {
            Address: {
                OurAddress: ITranslation
            },
            Parking: {
                ParkAt: ITranslation,
                SecondChoice: ITranslation,
                SaveLocation: ITranslation,
                PleaseSelectPlaceholder: ITranslation
            },
            Entrance: {
                EnterAt: ITranslation,
                Proceed: ITranslation,
                RegisterFirst: ITranslation,
                Afterwards: ITranslation,
                DropOff: ITranslation,
                To: ITranslation
            }
        }
    },
    SplashText: ITranslation
}

const UITranslations: IUITranslations = {
    PhotoRoutePage: {
        FrequentlyUsed: { id: 273, default: "Frequently used" },
        OtherDestinations: { id: 274, default: "Other destinations" },
        ControlsPanel: {
            LeftSide: {
                FromLabel: { id: 87, default: "From" },
                FromPlaceholder: { id: 55, default: "Select starting point" },
                ToLabel: { id: 88, default: "To" },
                ToPlaceholder: { id: 85, default: "Select destination" }
            }
        },
        WelcomeBanner: {
            ImportantHeader: { id: 269, default: "Important" }
        },
        PathRating: {
            Question: { id: 138, default: "Was this instruction helpful?" },
            PositiveAnswer: { id: 16, default: "Yes" },
            NegativeAnswer: { id: 17, default: "No" },
            ThankYouMessage: { id: -1, default: "Thank you for the feedback!" }
        },
        ReverseRouteLink: { id: 251, default: "Reverse route" },
        PathNotFound: { id: 249, default: "No route could be found from selected starting point and selected end point"},
        Location: { id: 275, default: "Location <%= nodeId %>" },
    },
    GettingToPage: {
        HeaderQuestion: { id: 253, default: "How to get to your appointment?" },
        ArrivingByCar: { id: 252, default: "I am arriving by car" },
        ParkTheCar: { id: 263, default: "I want to park the car" },
        Wizard: {
            Address: {
                OurAddress: { id: 254, default: "Our address is:" }
            },
            Parking: {
                ParkAt: { id: 255, default: "Park at" },
                SecondChoice: { id: 259, default: "2nd choice:" },
                SaveLocation: { id: 258, default: "Save your parking location:" },
                PleaseSelectPlaceholder: { id: 265, default: "Please select" },
            },
            Entrance: {
                EnterAt: { id: 256, default: "Enter at:" },
                Afterwards: { id: 261, default: "Afterwards, please proceed" },
                DropOff: { id: 264, default: "Drop off / enter at:" },
                Proceed: { id: 257, default: "Proceed" },
                RegisterFirst: { id: 260, default: "You need to register first." },
                To: { id: 262, default: "to" }
            },

        }
    },
    SplashText: { id: 250, default: "Please, wait..." }
}

export default UITranslations;
